import { render, staticRenderFns } from "./FactsRow.vue?vue&type=template&id=64476106&"
import script from "./FactsRow.vue?vue&type=script&lang=js&"
export * from "./FactsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports